import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, Star } from "lucide-react";
import { motion } from "framer-motion";
import FloatingChildren from "./FloatingChildren";

const HeroSection = () => {
  return (
    <section className="relative overflow-hidden">

      <div className="container mx-auto pt-[80px] pb-4 sm:pb-8 relative z-10">
        <div className="max-w-4xl mx-auto text-center">

          {/* Floating children animation - above H1, extends to header */}
          <div className="relative h-[400px] sm:h-[440px] -mt-[80px] pt-[80px] mb-[-120px] bg-transparent z-0">
            <FloatingChildren />
          </div>

          {/* Main heading - above floating children. No entry animation: this is the LCP element. */}
          <h1 className="relative z-10 font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
            <span className="bg-gradient-to-r from-secondary to-primary bg-clip-text text-transparent pb-1 inline-block">
              Skapa unika barnböcker
            </span>{" "}
            <span className="text-foreground">med ditt barn som huvudperson</span>
          </h1>

          {/* Subheading */}
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="text-lg sm:text-xl text-muted-foreground max-w-2xl mx-auto mb-8"
          >
            Ladda upp ett foto, välj ett äventyr och låt AI skapa en personlig illustrerad berättelse. 
            Varje bok är unik – precis som ditt barn.
          </motion.p>

          {/* CTA Buttons */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
            className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-6"
          >
            <Button variant="cta" size="lg" className="text-sm sm:text-base" asChild>
              <Link to="/create" className="flex items-center gap-2 group">
                Skapa din första bok
                <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform" />
              </Link>
            </Button>
            <Button variant="outline" size="default" className="text-sm sm:text-base" asChild>
              <a href="#how-it-works">Se hur det fungerar</a>
            </Button>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default HeroSection;
